import useUserCountry from '~/hooks/useUserCountry';

export type MarkdownByRegion = Readonly<
  { default: string } & Partial<Record<string, string>>
>;

const useLegalMarkdownByCountry = (
  markdownByRegion: MarkdownByRegion,
): { markdown: string; ready: boolean } => {
  const countryCode = useUserCountry('');

  if (!countryCode) {
    return { markdown: markdownByRegion.default, ready: false };
  }

  const markdown = markdownByRegion[countryCode] ?? markdownByRegion.default;
  return { markdown, ready: true };
};

export default useLegalMarkdownByCountry;
